import axios from 'axios';
import api, {API_URL} from "./ApiBuilder";


export const getWorkshopById = (id) => api.get(`/${id}`);
export const createWorkshop = (workshop) => api.post("", workshop);
export const updateWorkshop = (id, workshop) => api.put(`/${id}`, workshop);

export const getWorkshopLoadData = (workshopId) => {
    return api.get(`/workshops/${workshopId}/load`);
}

export const loginEmployee = (email, password) => {
    return api.post(`/employees/login`, { email, password });
};

export const loginUser = (data) => {
    return  axios.post(`${API_URL}/auth/user/login`, { emailId: data.emailId, password: data.password });
};

export const registerUser = (data) => {
    return axios.post(`${API_URL}/auth/user/register`, {name: data.name,
        emailId: data.email,
        password: data.password,
        workshopId: data.workshopId
    });
};

// API to get employee count for a specific workshop
export const getEmployeeCount = (workshopId) => {
    return api.get(`/workshops/${workshopId}/employees/count`);
};



export const getEmployeeProfile = (employeeId) => {
    return  api.get(`/employees/${employeeId}`)
}

export const getEmployeeReportData = (employeeId, workshopId)=> {
    return  api.get(`/employees/${employeeId}/efficiency?workshopId=${workshopId}`)
}
export const getEmployeeWorkHistory = (employeeId) => {
    return  api.get(`/employees/${employeeId}/history`)
}

export const addEmployee = (newEmployee) => {
    return api.post(`/employees`, {id: newEmployee.id,
        name: newEmployee.name,
        phone: newEmployee.phone,
        position: newEmployee.position,
        workshopId:newEmployee.workshopId})
}
// API to get customer count for a specific workshop
export const getCustomerCount = (workshopId) => {
    return api.get(`/workshops/${workshopId}/customers/count`);
};

export const addCustomer = (workshopId, customer) => {
    api.post(`/workshop/${workshopId}/customers`, {name: customer.name,
        phone:customer.phone,
        address: customer.address,
        workshopId: workshopId});
}

export const updateCustomer = (workshopId, customer) => {
    return api.put(`/customer/${customer.id}`, {id: customer.id,
        name: customer.name,
        address: customer.address,
        phone:customer.phone, workshopId: workshopId});
}

export const uploadCustomerPhoto = (customerId, formData) => {
    return  api.post(`/customer/${customerId}/upload-photo`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
}

//dashobard stats

export const getMetricsByWorkshopId = (workshopId) => {
    return  api.get(`/workshops/${workshopId}/dashboard/metrics`);
}

export const getEmployeeForWorkshop = (workshopId, size, page) => {
    return api.get(`/workshops/${workshopId}/employees?size=${size}&page=${page}  `);
};

export const getCustomersForWorkshop = (workshopId, size=0, page=5, searchTerm) => {
    return api.get(`/workshop/${workshopId}/customers?page=${page}&size=${size}&search=${searchTerm}`);
};


export const getWorkTypeByWorkshopId = (workshopId) => {
    return api.get(`/workshops/${workshopId}/worktypes`);
};

export const addWorkTypeForWorkshopId = (workshopId, name, price) => {
    return api.post(`/workshops/${workshopId}/worktypes`, {name, price});
};

export const updateWorkTypeForWorkshopId = (workshopId, workTypeId, name, price) => {
    return api.put(`/workshops/${workshopId}/worktypes/${workTypeId}`, { name, price});
};

export const deleteWorkType = (id) => api.delete(`/worktypes/${id}`);

export const getAssetsForWorkshop = (workshopId, size=10, page=1, assetType= "") => {
    return api.get(`/workshops/${workshopId}/assets?assetType=${assetType}&page=${page}&size=${size}`);
}
export const getAssetStatsForWorkshop = (workshopId) => {
    return api.get(`/workshops/${workshopId}/assets/stats`);
}


export const deleteAsset = (id) => {
    return  api.delete(`/assets/${id}`);
}

export const addAssetForWorkshop = (workshopId, data) => {
    return api.post(`/workshops/${workshopId}/assets`, data);
};

export const assignAssetForCustomer = (data) => {
    return api.post(`/customer-assets/assign`, data);
};

export const unAssignAssetForCustomer = (id) => {
    return api.post(`/customer-assets/unassign/${id}`);
};

export const searchAssetsForWorkshop = (workshopId, query, type, page) => {
    return api.get(`/workshops/${workshopId}/assets/search?query=${query}&asset_type=${type}&page=${page}`);
}

export const uploadComplainceDocument = (assetId, formData) => {
    return  api.post(`/customer-assets/${assetId}/upload-compliance`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
}

export const getComplainceDocument = (assetId) => {
    return  api.get(`/customer-assets/${assetId}/compliance-documents`);
}


export const getJobCardsByWorkshopId = (workshopId, filter, size=0, page=5, search) => {
    return api.get(`/workshops/${workshopId}/jobcards?status=${filter}&page=${page}&size=${size}&search=${search}`);
};

export const addJobCardForWorkshopId = (workshopId, jobCard) => {
    return api.post(`/workshops/${workshopId}/jobcards`,
        {customerId: jobCard.customerId,
            workTypes: jobCard.workTypes,
            vehicleNumber: jobCard.vehicleNumber,
            estimatedTime: jobCard.estimatedTime,
            inventoryItems: jobCard.inventoryItem
        });
};

export const deleteJobCard = (jobCardId) => {
    return api.delete(`/jobcards/${jobCardId}`);
};
export const getJobCardDetails = (jobCardId) => {
    return api.get(`/jobcards/${jobCardId}`);
};



export const updateJobCardForWorkshopId = (workshopId, jobCardId, jobCard) => {
    return api.put(`/workshops/${workshopId}/jobcard/${jobCardId}`, {customerId: jobCard.customerId,
        assignedEmployees: jobCard.employeeIds,
        workTypes: jobCard.workTypeIds,
        vehicleNumber: jobCard.vehicleNumber,
        inventoryItems: jobCard.inventoryItems});
};

export const assignEmployeesToJobCard = async (jobCardId, employeeIds) => {
    return  api.put(`/jobcards/${jobCardId}/assign-employees`, { employeeIds: employeeIds });
};

export const updateJobCardStatus = async (jobCardId, status) => {
    return api.put(`/jobcards/${jobCardId}/status`, { status });
};

// Fetch customer history
export const fetchCustomerHistory = async (customerId) => {
    return await api.get(`/visit/customer/${customerId}/history`);
};

export const fetchCustomerProfile = async (customerId) => {
    return await api.get(`/customer/${customerId}/profile`);
};
export const payCustomerDues = (customerId, amount) => {
    return api.post(`/customers/${customerId}/pay-dues`, { amount });
};
//inventory

export const getInventoryForWorkshop = async (workshopId, size, page,search) => {
    if(search !== undefined) {
        return await api.get(`/workshops/${workshopId}/inventory?page=${page}&size=${size}&search=${search}`);
    }
    return await api.get(`/workshops/${workshopId}/inventory?page=${page}&size=${size}`);

}

export const updateInventoryForWorkshop = async (id, workshopId, item) => {
    return await api.put(`/workshops/${workshopId}/inventory/${id}`,
        {name:item.name,
            type: item.type ,
            quantity: item.quantity,
            price: item.price,
            warrantyType: item.warrantyType,
            warrantyPeriod: item.warrantyPeriod
        }
    );
}

export const addInventoryForWorkshop = async (workshopId, item) => {
    return await api.post(`/workshops/${workshopId}/inventory`,
        {name:item.name,
            type: item.type ,
            quantity: item.quantity,
            price: item.price,
            warrantyType: item.warrantyType,
            warrantyPeriod: item.warrantyPeriod
        }
    );
}

export const deleteInventoryForWorkshop = async (workshopId, id) => {
     return await api.delete(`/workshops/${workshopId}/inventory/${id}`);
}

export const getInventoryUsageForWorkshop = (workshopId) => {
    return  api.get(`/workshops/${workshopId}/inventory/usage`);
};

export const getEstimatedPrice = async (jobCard) => {
     return await api.get(`/jobcards/${jobCard.jobCardId}/estimated-price`);
}

export const gneerateBill = async (jobCard, discount,redeemPoints, extraCharges, comment) => {
     return await api.post(`/jobcards/${jobCard.jobCardId}/bill/generate`,
         { discount: discount, redeemPoints:redeemPoints, extraCharges:extraCharges, comment }
     )
}

export const updateBillStatus = (billId, status) =>
    api.put(`/bills/${billId}/status`, { status });


export const billPay = (billId, amount) =>
    api.put(`/bills/${billId}/pay`, {amount });

export const getBills =  (workshopId, page, size,search, status) => {
    return  api.get(`/workshop/${workshopId}/bills?page=${page}&size=${size}&search=${search}&status=${status}`)
}

export const getBillDetails = (billId) => {
    return  api.get(`/bills/${billId}`)
}

export const getWorkshopReport = (workshopId) => {
    return api.get(`/reports/workshop/${workshopId}/performance`)
}

export const getEmployeePerformanceForWorkshop = (workshopId) => {
    return api.get(`/reports/employee-efficiency/${workshopId}`)
}

export const getJobcardTurnaroundForWorkshop = (workshopId) => {
    return api.get(`/reports/job-turnaround/${workshopId}`)
}

export const getRevenueTrendsForWorkShop = (workshopId) => {
    return api.get(`/reports/revenue-trends/${workshopId}`)
}


export const getLoansByWorkshop =(workshopId,size=0, page=0, search ) => {
    return  api.get(`/loans/workshop/${workshopId}?page=${page}&size=${size}&search=${search}`);
}



export const calculatePaastPenatly = (loanId) => {
    return api.post(`/loans/${loanId}/calculate-penalty`);
}

export const createLoan = (loanData) => {
    return api.post(`/loans`, {
        customerId: loanData.customerId,
        workshopId: loanData.workshopId,
        amount: loanData.amount,
        downPayment: loanData.downPayment,
        tenure: loanData.tenure,
        interestRate: loanData.interestRate,
        startDate: loanData.startDate,
        loanType: loanData.loanType,
        branchId: loanData.branchId,
    });
};


export const getLoansDetails =(loanId ) => {
    return  api.get(`/loans/${loanId}`);
}

export const deleteLoan = (id) => api.delete(`/loans/${id}`);

export const markEmiAsPaid = (emiId) => {
    return api.put(`/emis/${emiId}/mark-paid`);
};

export const payEmiAmount = (emiId, amount) => {
    return api.post(`/emis/${emiId}/pay?amountPaid=${amount}`)
}

export const emiPaymentDetials =(emiId) =>{
    return api.get(`/emis/${emiId}/details`)
}

export const getPendingEMIsForWorkshop = (workshopId, size, page, status) => {
    return api.get(`/emis/pending/${workshopId}?page=${page}&size=${size}&status=${status}`);
}

export const getAllEMIsForWorkshop = (workshopId, size, page, status, year, month) => {
    return api.get(`/emis/${workshopId}?page=${page}&size=${size}&status=${status}&year=${year}&month=${month}`);
}

export const pauseEmi = (emiId) => {
    return api.post(`/emis/${emiId}/pause`);
};


export const getLoanStatusBreakdown = (workshopId) => {
    return api.get(`/loan-analytics/loan-status-breakdown?workshopId=${workshopId}`)
}

export const getFaultyLoansByWorkshop = (workshopId, size, page,searchTerm) => {
    return api.get(`/loan-analytics/faulty?workshopId=${workshopId}&page=${page}&size=${size}&search=${searchTerm}`)
}




export const getLoanStatistics = (workshopId) => {
    return api.get(`/workshop/${workshopId}/dashboard-stats`)
}

export const getEmiPaymentPerformance = (workshopId) => {
    return api.get(`/loan-analytics/emi-payment-performance?workshopId=${workshopId}`)
}

export const getFetchRevenueTrends = (workshopId) => {
    return api.get(`/loan-analytics/revenue-trends?workshopId=${workshopId}`)
}

export const uploadLoanDocument = (loanId, formData) => {
    return  api.post(`/loans/${loanId}/documents`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
}


export const getLoansDocuments =(loanId ) => {
    return  api.get(`/loans/${loanId}/documents`);
}

export const deleteLoanDocument = (docId) => {
    return api.delete(`/loans/documents/${docId}`);
};

export const calculateSettlement = (loanId, type = "DISCOUNTED_PAYMENT") =>
    api.get(`loans/${loanId}/settlement/calculate?type=${type}`);

export const createSettlement = (loanId, payload) =>
    api.post(`/loans/${loanId}/settlement`, {
        type: payload.type,
        calculatedAmount: payload.calculatedAmount,
        actualPaidAmount: payload.actualPaidAmount,
        notes: payload.notes
    });

export const purchaseLoyaltyCard = (customerId, cardType) => {

    return api.post(`/loyalty-cards/purchase`, {
       customerId: customerId,
        cardType: cardType
    })

};

export const renewLoyaltyCard = (customerId, cardType) => {

    return api.post(`/loyalty-cards/renew`, {
        customerId: customerId,
        cardType: cardType
    })

};

export const fetchLoyaltySummary = () => api.get(`/loyalty-cards/summary`);
export const fetchMonthlyRevenue = (months = 12) => api.get(`/loyalty-cards/monthly-revenue?months=${months}`);
export const fetchMonthlyPoints = (months = 12) => api.get(`/loyalty-cards/monthly-points?months=${months}`);

export const fetchLoyaltyCardsList = (workshopId, page, size, status) => {
   return  api.get(`/loyalty-cards/workshop/${workshopId}?page=${page}&size=${size} &status=${status}`);
}

export const getMonthlyLoanDistribution = (workshopId, months = 12) => {
    return api.get(`/workshop/${workshopId}/monthly-distribution?months=${months}`);
};

export const getMonthlyLoanDisbursement = (workshopId, months = 12) => {
    return api.get(`/workshop/${workshopId}/monthly-disbursement?months=${months}`);
};

export const getAverageTicketSize = (workshopId, months = 12) => {
    return api.get(`/workshop/${workshopId}/average-ticket-size?months=${months}`);
};

export const getMoMGrowth = (workshopId) => {
    return api.get(`/workshop/${workshopId}/mom-growth`);
};

export const getEMIBounceRate = (workshopId) => {
    return api.get(`/workshop/${workshopId}/emi-bounce-rate`);
};

export const getWeightedAverageYield = (workshopId) => {
    return api.get(`/workshop/${workshopId}/weighted-average-yield`);
};

export const getCostOfFunds = (workshopId) => {
    return api.get(`/workshop/${workshopId}/cost-of-funds`);
};

export const getMonthlyLoanDisbursementPerBranch = (workshopId) => {
    return api.get(`/workshop/${workshopId}/branch-disbursement`);
}

export const getBranches = (page, size) => api.get(`/branches?page=${page}&size=${size}`);
export const addBranch = (data) => api.post(`/branches`, data);
export const updateBranch = (id, data) => api.put(`/branches/${id}`, data);
export const deleteBranch = (id) => api.delete(`/branches/${id}`);

export const getOperationalExpenses = (workshopId, page = 0, size = 10) => {
    return api.get(`/workshop/${workshopId}/operational-expenses`, {
        params: { page, size }
    });
};

export const getMonthlyStats = (workshopId) => {
    return api.get(`/workshop/${workshopId}/operational-expenses/stats/monthly`);
};

export const createOperationalExpense = (workshopId, expenseData) => {
    return api.post(`/workshop/${workshopId}/operational-expenses`, expenseData);
};

export const updateOperationalExpense = (workshopId,expenseId, expenseData) => {
    return api.put(`/workshop/${workshopId}/operational-expenses/${expenseId}`, expenseData);
};

export const deleteOperationalExpense = (expenseId) => {
    return api.delete(`/workshop/operational-expenses/${expenseId}`);
};
export const recalculateSingleLoanPenalties = (loanId, dryRun = true) => {
    // Matches: POST /api/v1/admin/maintenance/loans/recalculate-penalties-single?loanId=X&dryRun=Y
    return api.get(`/v1/admin/maintenance/loans/recalculate-penalties-single?loanId=${loanId}&dryRun=${dryRun}`);
};

// Data Tools (read-only, no-code data explorer)
export const getDataToolsDatasets = () => api.get(`/data-tools/datasets`);

// `query` must include the logged-in workshopId (see toRequest in DataTools/dataToolsUtils.js).
export const runDataToolsQuery = (query) => api.post(`/data-tools/query`, query);

export const getDataToolsFieldValues = (workshopId, dataset, field, search = "") =>
    api.get(`/data-tools/datasets/${dataset}/fields/${field}/values`, {
        params: { workshopId, search }
    });
